import { GET_WEBSTATS_HEAD } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const webstatsHeadReducer = (state = initialState, action = {}) => {
    switch (action.type) {
    case `${GET_WEBSTATS_HEAD}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_WEBSTATS_HEAD}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_WEBSTATS_HEAD}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
